// start:ng42.barrel
export * from './crm-entities.model';
export * from './crm-entities.service';
export * from './crm-entities-consts';
// end:ng42.barrel

